var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "baseInfo" } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass(
                    "vesselCode,vesselName,vesselNameCn,voyageNo,voyageLeg"
                  ),
                  attrs: { label: _vm.$t("home.vesselAndVoyage") },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                    ],
                    attrs: { disabled: true },
                    model: {
                      value: _vm.vessNameVoy,
                      callback: function ($$v) {
                        _vm.vessNameVoy = $$v
                      },
                      expression: "vessNameVoy",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("saillingDate"),
                  attrs: {
                    prop: "saillingDate",
                    label: _vm.$t("home.sailingTime"),
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm",
                      placeholder: "",
                      disabled: true,
                    },
                    model: {
                      value: _vm.form.saillingDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "saillingDate", $$v)
                      },
                      expression: "form.saillingDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("eta"),
                  attrs: { prop: "eta", label: _vm.$t("home.arrivalTime") },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      disabled: true,
                      type: "date",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm",
                      placeholder: "",
                    },
                    model: {
                      value: _vm.form.eta,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "eta", $$v)
                      },
                      expression: "form.eta",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bookingFwdPerson"),
                  attrs: {
                    prop: "bookingFwdPerson",
                    label: _vm.$t("home.contactCustomer"),
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      onblur: "this.value = this.value.toUpperCase()",
                      disabled: _vm.preLockFlag,
                    },
                    model: {
                      value: _vm.form.bookingFwdPerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingFwdPerson", $$v)
                      },
                      expression: "form.bookingFwdPerson",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bookingFwdTel"),
                  attrs: {
                    prop: "bookingFwdTel",
                    label: _vm.$t("home.mobilePhone"),
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      onblur: "this.value = this.value.toUpperCase()",
                      disabled: _vm.preLockFlag,
                    },
                    model: {
                      value: _vm.form.bookingFwdTel,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingFwdTel", $$v)
                      },
                      expression: "form.bookingFwdTel",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bookingFwdEmail"),
                  attrs: {
                    prop: "bookingFwdEmail",
                    label: _vm.$t("home.emailPlus"),
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      onblur: "this.value = this.value.toUpperCase()",
                      disabled: _vm.preLockFlag,
                    },
                    model: {
                      value: _vm.form.bookingFwdEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingFwdEmail", $$v)
                      },
                      expression: "form.bookingFwdEmail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("actualShipper"),
                  attrs: {
                    prop: "actualShipper ",
                    label: _vm.$t("home.people"),
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 100,
                        expression: "100",
                      },
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      onblur: "this.value = this.value.toUpperCase()",
                      disabled:
                        _vm.preLockFlag ||
                        (_vm.form.pol.startsWith("TH") &&
                          !_vm.validateNull(_vm.form.actualShipper)),
                    },
                    model: {
                      value: _vm.form.actualShipper,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "actualShipper", $$v)
                      },
                      expression: "form.actualShipper ",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("bkNo"),
                  attrs: { prop: "bkNo", label: _vm.$t("home.bkNo") },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 20,
                        expression: "20",
                      },
                    ],
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.bkNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bkNo", $$v)
                      },
                      expression: "form.bkNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("blNo"),
                  attrs: { prop: "blNo", label: _vm.$t("home.blNo") },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                    ],
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.blNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "blNo", $$v)
                      },
                      expression: "form.blNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "bookingType",
                    label: _vm.$t("home.bookingType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      class: _vm.inputClass("bookingType"),
                      attrs: {
                        clearable: "",
                        disabled:
                          _vm.preLockFlag ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("TH")),
                      },
                      model: {
                        value: _vm.form.bookingType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bookingType", $$v)
                        },
                        expression: "form.bookingType",
                      },
                    },
                    _vm._l(_vm.bookingTypeList, function (item) {
                      return _c("el-option", {
                        key: item.codeValue,
                        attrs: {
                          label:
                            _vm.language === "zh"
                              ? item.displayValueCn
                              : item.displayValue,
                          value: Number(item.codeValue),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  attrs: {
                    prop: "transportationTerms",
                    label: _vm.$t("home.transportationTerms"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      class: _vm.inputClass("transportationTerms"),
                      attrs: {
                        clearable: "",
                        disabled:
                          _vm.preLockFlag ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("MY")) ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("TH")),
                      },
                      model: {
                        value: _vm.form.transportationTerms,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "transportationTerms", $$v)
                        },
                        expression: "form.transportationTerms",
                      },
                    },
                    _vm._l(_vm.transportationTermsList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: String(item), value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: {
                    reqired: _vm.form.pol == "CNSHK" || _vm.form.pol == "CNNSA",
                  },
                  attrs: { prop: "paidPalce", label: _vm.$t("home.paidPalce") },
                },
                [
                  _c("glPort", {
                    class: _vm.inputClass("paidPalce"),
                    attrs: {
                      disabled:
                        _vm.preLockFlag ||
                        _vm.form.pol === "CNTAO" ||
                        _vm.form.pol === "HKHKG" ||
                        (!_vm.validateNull(_vm.form.pol) &&
                          _vm.form.pol.startsWith("TH")),
                    },
                    model: {
                      value: _vm.form.paidPalce,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "paidPalce", $$v)
                      },
                      expression: "form.paidPalce",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  attrs: { prop: "paidType", label: _vm.$t("home.paidType") },
                },
                [
                  _c(
                    "el-select",
                    {
                      class: _vm.inputClass("paidType"),
                      attrs: {
                        clearable: "",
                        disabled:
                          _vm.preLockFlag ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("MY")) ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("TH")),
                      },
                      on: { change: _vm.handlePaidTypeChange },
                      model: {
                        value: _vm.form.paidType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "paidType", $$v)
                        },
                        expression: "form.paidType",
                      },
                    },
                    _vm._l(_vm.paidTypeList, function (item) {
                      return _c("el-option", {
                        key: item.codeValue,
                        attrs: {
                          label:
                            _vm.language === "zh"
                              ? item.displayValueCn
                              : item.displayValue,
                          value: Number(item.codeValue),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("deliveryDocumentMethod"),
                  attrs: {
                    prop: "deliveryDocumentMethod",
                    label: _vm.$t("home.documentType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled:
                          (_vm.preLockFlag ||
                            (_vm.form.pol && _vm.form.pol.startsWith("KR")) ||
                            (_vm.form.pol &&
                              _vm.MYXXXArray.includes(_vm.form.pol)) ||
                            (!_vm.validateNull(_vm.form.pol) &&
                              _vm.form.pol.startsWith("TH"))) &&
                          !_vm.CNXMNDisabled &&
                          !(_vm.form.pol && _vm.form.pol === "CNTAO"),
                      },
                      model: {
                        value: _vm.form.deliveryDocumentMethod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deliveryDocumentMethod", $$v)
                        },
                        expression: "form.deliveryDocumentMethod",
                      },
                    },
                    _vm._l(_vm.documentTypeList, function (item) {
                      return _c("el-option", {
                        key: item.codeValue,
                        attrs: {
                          label:
                            _vm.language === "zh"
                              ? item.displayValueCn
                              : item.displayValue,
                          value: Number(item.codeValue),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: [
                    { reqired: _vm.form.deliveryDocumentMethod == "2" },
                    _vm.inputClass("wbillNo"),
                  ],
                  attrs: { prop: "wbillNo", label: _vm.$t("home.documentNo") },
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                    ],
                    attrs: {
                      disabled:
                        (_vm.form.deliveryDocumentMethod != "2" ||
                          _vm.preLockFlag) &&
                        !_vm.CNXMNDisabled,
                      onblur: "this.value = this.value.toUpperCase()",
                    },
                    model: {
                      value: _vm.form.wbillNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "wbillNo", $$v)
                      },
                      expression: "form.wbillNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("agreementNo"),
                  attrs: {
                    prop: "agreementNo",
                    label: _vm.$t("home.agreementNo"),
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      onblur: "this.value = this.value.toUpperCase()",
                      disabled:
                        !_vm.validateNull(_vm.form.pol) &&
                        _vm.form.pol.startsWith("TH"),
                    },
                    model: {
                      value: _vm.form.agreementNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "agreementNo", $$v)
                      },
                      expression: "form.agreementNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("freeTimeNo"),
                  attrs: { prop: "freeTimeNo", label: _vm.$t("home.ft") },
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                    ],
                    attrs: {
                      onblur: "this.value = this.value.toUpperCase()",
                      disabled:
                        _vm.preLockFlag ||
                        (!_vm.validateNull(_vm.form.pol) &&
                          _vm.form.pol.startsWith("MY")) ||
                        (!_vm.validateNull(_vm.form.pol) &&
                          _vm.form.pol.startsWith("TH")),
                    },
                    model: {
                      value: _vm.form.freeTimeNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "freeTimeNo", $$v)
                      },
                      expression: "form.freeTimeNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { prop: "stuffType", label: _vm.$t("home.stuffType") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", disabled: "" },
                      model: {
                        value: _vm.form.stuffType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "stuffType", $$v)
                        },
                        expression: "form.stuffType",
                      },
                    },
                    _vm._l(_vm.stuffTypeList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: [
                    { reqired: _vm.form.pol && _vm.form.pol.startsWith("KR") },
                    _vm.inputClass("expCustomsCargoType"),
                  ],
                  attrs: {
                    prop: "expCustomsCargoType",
                    label: _vm.$t("home.cargoType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        disabled:
                          _vm.preLockFlag ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("TH")),
                      },
                      model: {
                        value: _vm.form.expCustomsCargoType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "expCustomsCargoType", $$v)
                        },
                        expression: "form.expCustomsCargoType",
                      },
                    },
                    _vm._l(_vm.cargoListType, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: Number(item.code) },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: [
                    { reqired: _vm.form.pol && _vm.form.pol.startsWith("KR") },
                    _vm.inputClass("expCustomsCntrType"),
                  ],
                  attrs: {
                    prop: "expCustomsCntrType",
                    label: _vm.$t("home.customsType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        disabled:
                          _vm.preLockFlag ||
                          (!_vm.validateNull(_vm.form.pol) &&
                            _vm.form.pol.startsWith("TH")),
                      },
                      model: {
                        value: _vm.form.expCustomsCntrType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "expCustomsCntrType", $$v)
                        },
                        expression: "form.expCustomsCntrType",
                      },
                    },
                    _vm._l(_vm.expCustomsCntrTypeList, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: Number(item.code) },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("sales"),
                  attrs: { prop: "sales", label: _vm.$t("home.sales") },
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "uppercase", rawName: "v-uppercase" },
                      { name: "trim", rawName: "v-trim" },
                      { name: "fth", rawName: "v-fth" },
                      {
                        name: "byte-length",
                        rawName: "v-byte-length",
                        value: 50,
                        expression: "50",
                      },
                    ],
                    attrs: {
                      disabled: !(_vm.form.pol && _vm.form.pol === "VNSGN"),
                      onblur: "this.value = this.value.toUpperCase()",
                    },
                    model: {
                      value: _vm.form.sales,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sales", $$v)
                      },
                      expression: "form.sales",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("por"),
                  attrs: { prop: "por", label: _vm.$t("home.por") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.por,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "por", $$v)
                      },
                      expression: "form.por",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("pol"),
                  attrs: { prop: "pol", label: _vm.$t("home.pol") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.pol,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pol", $$v)
                      },
                      expression: "form.pol",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("pod"),
                  attrs: { prop: "pod", label: _vm.$t("home.pod") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.pod,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pod", $$v)
                      },
                      expression: "form.pod",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("del"),
                  attrs: { prop: "del", label: _vm.$t("home.del") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.del,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "del", $$v)
                      },
                      expression: "form.del",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("porName"),
                  attrs: { prop: "porName" },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.portNameDisabled },
                    on: { change: _vm.changePorName },
                    model: {
                      value: _vm.form.porName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "porName", $$v)
                      },
                      expression: "form.porName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("polName"),
                  attrs: { prop: "polName" },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.portNameDisabled },
                    on: { change: _vm.changePolName },
                    model: {
                      value: _vm.form.polName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "polName", $$v)
                      },
                      expression: "form.polName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("podName"),
                  attrs: { prop: "podName" },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.portNameDisabled },
                    on: { change: _vm.changePodName },
                    model: {
                      value: _vm.form.podName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "podName", $$v)
                      },
                      expression: "form.podName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("delName"),
                  attrs: { prop: "delName" },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.portNameDisabled },
                    on: { change: _vm.changeDelName },
                    model: {
                      value: _vm.form.delName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "delName", $$v)
                      },
                      expression: "form.delName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "10px 0 16px 0" } },
        [
          _c(
            "el-checkbox",
            {
              class: _vm.inputClass("vipFlag"),
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              model: {
                value: _vm.form.vipFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "vipFlag", $$v)
                },
                expression: "form.vipFlag",
              },
            },
            [_vm._v("VIP")]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              class: _vm.inputClass("masterBlFlag"),
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              model: {
                value: _vm.form.masterBlFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "masterBlFlag", $$v)
                },
                expression: "form.masterBlFlag",
              },
            },
            [_vm._v("NVOCC")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "16px" },
              attrs: {
                disabled: false,
                icon: "el-icon-view",
                plain: "",
                type: "primary",
              },
              on: { click: _vm.handleOpenWebFeeItemComs },
            },
            [_vm._v(_vm._s(_vm.$t("home.additionalCharges")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                disabled: false,
                icon: "el-icon-view",
                plain: "",
                type: "primary",
              },
              on: { click: _vm.handleOpenwebBkYardComs },
            },
            [_vm._v(_vm._s(_vm.$t("home.terminalInfo")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                disabled: false,
                icon: "el-icon-view",
                plain: "",
                type: "primary",
              },
              on: { click: _vm.handleOpenwebBkDocumentComs },
            },
            [_vm._v("BK Document")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("home.additionalCharges"),
                isShowFollow: false,
                visible: _vm.webFeeItemComsDialogVisible,
                isShowFull: false,
              },
              on: {
                close: _vm.handleClose,
                "update:visible": function ($event) {
                  _vm.webFeeItemComsDialogVisible = $event
                },
              },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c("div", { staticClass: "filter-container-content" }, [
                _c(
                  "div",
                  { staticClass: "filter-container-title" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-plus",
                          disabled:
                            (_vm.preLockFlag && _vm.form.pol === "CNDLC") ||
                            _vm.isDisable ||
                            _vm.CNXMNDisabled,
                        },
                        on: { click: _vm.handleAddCharge },
                      },
                      [_vm._v(_vm._s(_vm.$t("home.additionalCharges")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table-container-new-back" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        attrs: { data: _vm.form.webFeeItemComs },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "feeItem",
                            label: _vm.$t("home.feeItem"),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                          { name: "trim", rawName: "v-trim" },
                                          { name: "fth", rawName: "v-fth" },
                                        ],
                                        attrs: {
                                          size: "small",
                                          disabled:
                                            (_vm.preLockFlag &&
                                              _vm.form.pol === "CNDLC") ||
                                            _vm.isDisable,
                                        },
                                        model: {
                                          value: scope.row.feeItem,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "feeItem", $$v)
                                          },
                                          expression: "scope.row.feeItem",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "payModel",
                            label: _vm.$t("home.payModel"),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            clearable: "",
                                            disabled:
                                              (_vm.preLockFlag &&
                                                _vm.form.pol === "CNDLC") ||
                                              _vm.isDisable,
                                          },
                                          model: {
                                            value: scope.row.payModel,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "payModel",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.payModel",
                                          },
                                        },
                                        _vm._l(
                                          _vm.paidTypeList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.codeValue,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.displayValueCn
                                                    : item.displayValue,
                                                value: Number(item.codeValue),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { width: "40px" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("i", {
                                    staticClass: "el-icon-remove-outline",
                                    attrs: {
                                      hidden:
                                        (_vm.preLockFlag &&
                                          _vm.form.pol === "CNDLC") ||
                                        _vm.isDisable,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRemoveCharge(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("home.terminalInfo"),
                isShowFollow: false,
                visible: _vm.webBkYardComsDialogVisible,
                isShowFull: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.webBkYardComsDialogVisible = $event
                },
              },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c("div", { staticClass: "filter-container-title" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-container-new-back" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      attrs: { data: _vm.form.webBkYardComs },
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: { prop: "pickupYard" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            disabled: "",
                                            filterable: "",
                                            clearable: "",
                                          },
                                          model: {
                                            value: scope.row.pickupYard,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "pickupYard",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.pickupYard",
                                          },
                                        },
                                        _vm._l(_vm.dataList, function (item) {
                                          return _c("el-option", {
                                            key: item.facilityCode,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.facilityNameCn
                                                  : item.facilityName,
                                              value: item.facilityCode,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm.form.pol == "CNTAO"
                            ? _c("template", { slot: "header" }, [
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(" *"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(_vm._s(_vm.$t("home.pickupYard"))),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.pol !== "CNTAO"
                            ? _c("template", { slot: "header" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.pickupYard"))),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: { prop: "returnYard" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            disabled: "",
                                            filterable: "",
                                            clearable: "",
                                          },
                                          model: {
                                            value: scope.row.returnYard,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "returnYard",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.returnYard",
                                          },
                                        },
                                        _vm._l(_vm.dataList, function (item) {
                                          return _c("el-option", {
                                            key: item.facilityCode,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.facilityNameCn
                                                  : item.facilityName,
                                              value: item.facilityCode,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm.form.pol == "CNTAO"
                            ? _c("template", { slot: "header" }, [
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(" *"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(_vm._s(_vm.$t("home.returnYard"))),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.pol !== "CNTAO"
                            ? _c("template", { slot: "header" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.returnYard"))),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: { prop: "pickupDate" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          disabled: "",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                          type: "date",
                                        },
                                        model: {
                                          value: scope.row.pickupDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "pickupDate",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.pickupDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm.form.pol == "CNTAO"
                            ? _c("template", { slot: "header" }, [
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(" *"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(_vm._s(_vm.$t("home.pickUpDate"))),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.pol !== "CNTAO"
                            ? _c("template", { slot: "header" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.pickUpDate"))),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: "BK Document",
                isShowFollow: false,
                width: "60%",
                visible: _vm.webBkDocumentComsVisible,
                isShowFull: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.webBkDocumentComsVisible = $event
                },
                close: _vm.handleBKDocumentClose,
              },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c(
                "div",
                { staticClass: "filter-container-title" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled: _vm.preLockFlag || _vm.isDisable,
                      },
                      on: { click: _vm.handleAddChargeBk },
                    },
                    [_vm._v("BK Document")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-container-new-back" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      attrs: { data: _vm.form.webBkDocumentComs },
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: { width: "130", prop: "documentNo" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkDocumentComs." +
                                          scope.$index +
                                          ".documentNo",
                                        rules: _vm.rules.documentNo,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 50,
                                            expression: "50",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                          { name: "trim", rawName: "v-trim" },
                                          { name: "fth", rawName: "v-fth" },
                                        ],
                                        attrs: {
                                          size: "small",
                                          disabled:
                                            _vm.preLockFlag || _vm.isDisable,
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.documentNo =
                                              scope.row.documentNo
                                                .replace(/[^a-zA-Z0-9]/g, "")
                                                .toUpperCase()
                                          },
                                        },
                                        model: {
                                          value: scope.row.documentNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "documentNo",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.documentNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm.form.pol.startsWith("KP")
                            ? _c("template", { slot: "header" }, [
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(" *"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required-marker" }, [
                                  _vm._v(_vm._s(_vm.$t("home.documentNoNew"))),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.form.pol.startsWith("KP")
                            ? _c("template", { slot: "header" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.documentNoNew"))),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "130",
                          prop: "packageCount",
                          label: _vm.$t("home.packageCount"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 99999999999999,
                                        disabled:
                                          _vm.preLockFlag || _vm.isDisable,
                                      },
                                      model: {
                                        value: scope.row.packageCount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "packageCount",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.packageCount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "130",
                          prop: "packageType",
                          label: _vm.$t("home.packageType"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          disabled:
                                            _vm.preLockFlag || _vm.isDisable,
                                        },
                                        model: {
                                          value: scope.row.packageType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "packageType",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.packageType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.form.pol.startsWith("KR")
                                          ? _vm.packageTypeListKR
                                          : _vm.packageTypeList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.packageCode,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.packageNameCn
                                                  : item.packageName,
                                              value: item.packageCode,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "weight", label: _vm.$t("home.weight") },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 3,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 88888888.999,
                                        disabled:
                                          _vm.preLockFlag || _vm.isDisable,
                                      },
                                      model: {
                                        value: scope.row.weight,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "weight",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.weight",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "isSplit",
                          label: _vm.$t("home.isSplit"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          disabled:
                                            _vm.preLockFlag || _vm.isDisable,
                                        },
                                        model: {
                                          value: scope.row.isSplit,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "isSplit", $$v)
                                          },
                                          expression: "scope.row.isSplit",
                                        },
                                      },
                                      _vm._l(_vm.isSplitList, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label:
                                              _vm.language === "zh"
                                                ? item.labelZh
                                                : item.labelEh,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "useTimes",
                          label: _vm.$t("home.useTimes"),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 9999,
                                        disabled:
                                          _vm.preLockFlag || _vm.isDisable,
                                      },
                                      model: {
                                        value: scope.row.useTimes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "useTimes",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.useTimes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { width: "40px" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("i", {
                                  staticClass: "el-icon-remove-outline",
                                  attrs: {
                                    hidden: _vm.preLockFlag || _vm.isDisable,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemoveBk(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }